import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination
} from '@mui/material';

interface ClassificationResult {
  keyword: string;
  topic: string;
  subtopic: string;
  relevance: number;
  confidence: number;
  location: boolean;
}

interface ResultsTableProps {
  results: ClassificationResult[];
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ResultsTable: React.FC<ResultsTableProps> = ({
  results,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange
}) => {
  const displayedResults = results.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  
  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Keyword</TableCell>
              <TableCell>Topic</TableCell>
              <TableCell>Subtopic</TableCell>
              <TableCell align="right">Confidence</TableCell>
              <TableCell align="center">Location</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedResults.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.keyword}</TableCell>
                <TableCell>{row.topic || "N/A"}</TableCell>
                <TableCell>{row.subtopic || "N/A"}</TableCell>
                <TableCell align="right">{(row.confidence * 100).toFixed(0)}%</TableCell>
                <TableCell align="center">
                  {row.location ? "Yes" : "No"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={results.length}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />
    </>
  );
};

export default ResultsTable;
